import {
  checkObjectKeyExists,
  isBoolean,
  isImage,
  isObject,
  isPdf,
  isVideo
} from "kwikid-toolkit";
import { EKwikUILabelValuePairType } from "./label-value-pair.definitions";

export const formatData = (data: any): any => {
  const formattedData: Array<{ key: any; value: any }> = [];

  for (const key in data) {
    if (checkObjectKeyExists(data, key)) {
      if (!isObject(data[key])) {
        formattedData.push({
          key,
          value: data[key]
        });
      } else if (checkObjectKeyExists(data[key], "key")) {
        formattedData.push(data[key]);
      }
    }
  }
  return formattedData;
};

export const assignTypeToValue = (value: any): string => {
  const stringifiedValue = value.toString();
  return isBoolean(value)
    ? EKwikUILabelValuePairType.BOOLEAN
    : isObject(value)
      ? EKwikUILabelValuePairType.OBJECT
      : isVideo(stringifiedValue)
        ? EKwikUILabelValuePairType.VIDEO
        : isPdf(stringifiedValue)
          ? EKwikUILabelValuePairType.PDF
          : isValidBase64Image(stringifiedValue) || isImage(stringifiedValue)
            ? EKwikUILabelValuePairType.IMAGE
            : isValidDocumentUrl(stringifiedValue)
              ? EKwikUILabelValuePairType.DOC
              : "";
};

// TOOLKIT
export const fixImageFormat = (image: string): string => {
  image = image.toString();
  if (!image?.startsWith("data:image") && isValidBase64Image(image)) {
    image = `data:image/png;base64,${image}`;
  }
  return image;
};

// TOOLKIT
export const isValidBase64Image = (url: string): boolean => {
  if (url.startsWith("data:image/")) {
    const base64Index = url.indexOf(";base64,");
    let slicedBase64String = "";
    if (base64Index !== -1) {
      slicedBase64String = url.slice(base64Index);
    }
  }
  const imageTypes = ["PNG", "JPG", "JPEG", "BMP", "GIF", "SVG"];
  let binaryValue = "";
  try {
    binaryValue = atob(url);
  } catch (error) {
    // console.log("Not a valid Base64 input: ", error);
  }
  return !!imageTypes.some((format) => binaryValue.includes(format));
};

export const isValidDocumentUrl = (url: string): boolean => {
  // Array of document formats
  const documentFormats = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf"];

  // Get the file extension from the URL
  const urlParts = url.split(".");
  const extension = urlParts[urlParts.length - 1].toLowerCase();

  // Check if the extension exists in the documentFormats array
  return documentFormats.includes(extension);
};
